import { render } from "./YouTubeViewer.vue?vue&type=template&id=2489ac78&ts=true"
import script from "./YouTubeViewer.vue?vue&type=script&lang=ts"
export * from "./YouTubeViewer.vue?vue&type=script&lang=ts"

import "./YouTubeViewer.vue?vue&type=style&index=0&id=2489ac78&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__